import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

// SVG
import NextIcon from '.././../icons/nextIcon.inline.svg'

import styles from './navigationArrows.module.scss'
// Color Constants
export enum ARROW_COLOR {
  WHITE = 'white',
  BLACK = 'black',
}

export interface NavigationArrowsProps {
  nextButtonDisabled?: boolean
  prevButtonDisabled?: boolean
  color?: ARROW_COLOR
  navOnRight?: boolean
  hideArrowOnMobile?: boolean
  className?: string
  onPrevClick: () => void
  onNextClick: () => void
}

const NavigationArrows = ({
  nextButtonDisabled = false,
  prevButtonDisabled = false,
  hideArrowOnMobile = false,
  color = ARROW_COLOR.BLACK,
  className = '',
  ...props
}: NavigationArrowsProps) => {
  const iconButtonClasses = classnames(styles.button, styles.icon, styles[`icon_color__${color}`])
  const { t } = useTranslation('common')
  const classNames = classnames(styles.navContainer, { [styles.hideOnMobile]: hideArrowOnMobile }, className)
  return (
    <div className={classNames}>
      <button
        className={iconButtonClasses}
        onClick={props.onPrevClick}
        disabled={prevButtonDisabled}
        aria-label={t('previous')}
      >
        <NextIcon className={classnames(styles.prevIcon, styles.iconSize)} />
      </button>
      <button
        className={iconButtonClasses}
        onClick={props.onNextClick}
        disabled={nextButtonDisabled}
        aria-label={t('next')}
      >
        <NextIcon className={styles.iconSize} />
      </button>
    </div>
  )
}

export default NavigationArrows
